var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToothIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0746 10.7929C26.2819 10.6294 34.9496 3.88668 40.6788 10.5294C43.8246 14.1752 43.558 17.9596 42.3913 21.6648L38.2851 33.4283C37.084 37.519 36.2278 38.7825 34.1236 40.5586C32.8757 41.6138 31.4673 39.7919 29.9851 37.8742C28.7007 36.2127 27.3611 34.4804 26.0226 34.4846C24.6611 34.4888 23.2996 36.2242 21.9976 37.8846C20.4965 39.7992 19.0726 41.6148 17.8173 40.5586C15.283 38.4252 14.1715 35.4783 13.009 30.7481C12.7851 29.8377 12.4455 28.745 12.0694 27.5398C10.4965 22.4888 8.30693 15.4617 11.5173 11.5638C15.483 6.74918 20.408 5.97418 26.0215 10.7544L26.0746 10.7929Z",
    fill: "#2DA4AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothIconSelected);
export default __webpack_public_path__ + "static/media/tooth-icon-selected.e6a0fce69b173d05aeb45d13ddf059de.svg";
export { ForwardRef as ReactComponent };